import {
  MasonryDriverAction,
  MasonrySubmitFormAction,
} from '@leagueplatform/masonry-renderers';
import { MasonryEngineActionHandler } from '@leagueplatform/masonry-engine';
import { getVisibleFormFieldNodes } from '../utils/form-validation-utils';
import { submitFormWithValidation } from '../utils/form-submission-base';

/**
 * Submit form action handler
 *
 * This handler submits all visible fields for the given form.
 */
export const SubmitFormActionHandler: MasonryEngineActionHandler<
  MasonrySubmitFormAction,
  MasonryDriverAction
> = async (
  {
    payload: { formId, formProcessorId, onSuccessDeepLink, suppressErrorModal },
    namespace,
    ancestry,
    event,
  },
  resources,
) => {
  const { invokeAction, stateController } = resources;
  const allFieldNodes = getVisibleFormFieldNodes(formId, stateController);

  const result = await submitFormWithValidation({
    formId,
    formProcessorId,
    fieldNodes: allFieldNodes,
    namespace,
    ancestry,
    event,
    resources,
    isBlocking: true,
    suppressErrorModal,
  });

  if (result.isSuccess && onSuccessDeepLink) {
    await invokeAction({
      type: 'deeplink',
      namespace,
      ancestry,
      event,
      payload: { url: onSuccessDeepLink },
    });
  }

  return result;
};
